import { render, staticRenderFns } from "./battleNet.vue?vue&type=template&id=6fea912d&scoped=true"
import script from "./battleNet.vue?vue&type=script&lang=js"
export * from "./battleNet.vue?vue&type=script&lang=js"
import style0 from "./battleNet.vue?vue&type=style&index=0&id=6fea912d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fea912d",
  null
  
)

export default component.exports